import React from 'react';
import PropTypes from 'prop-types';
import useOnboardingStatus from '../../hooks/useOnboardingStatus';
import LoadingSpinner from '../../components/LoadingSpinner';
import StoreBar from './cards/StoreBar';
import StatsStrip from './cards/StatsStrip';
import PacksCard from './cards/PacksCard';
import TournamentCard from './cards/TournamentCard';
import CampaignsCard from './cards/CampaignsCard';
import RecentGamesCard from './cards/RecentGamesCard';
import LeaderboardCard from './cards/LeaderboardCard';
import PlayoffCard from './cards/PlayoffCard';
import OnboardingView from './OnboardingView';

const DashboardPage = ({ userID }) => {
    const { done, loading } = useOnboardingStatus();

    if (loading) return <LoadingSpinner />;

    return (
        <div className="dashboard-container">
            <StoreBar />
            <StatsStrip />
            <PacksCard />
            <div className="dash-stack">
                {done ? (
                    <>
                        <PlayoffCard />
                        <TournamentCard />
                        <CampaignsCard />
                        <RecentGamesCard userID={userID} />
                        <LeaderboardCard />
                    </>
                ) : (
                    <OnboardingView />
                )}
            </div>
        </div>
    );
};

DashboardPage.propTypes = {
    userID: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DashboardPage;
